// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type Props = SvgIconProps

const EditIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M19.3998 7.33986L16.6598 4.59986C16.3022 4.26395 15.8336 4.07122 15.3431 4.05831C14.8527 4.0454 14.3746 4.21323 13.9998 4.52986L4.99981 13.5299C4.67657 13.8558 4.47531 14.2831 4.42981 14.7399L3.99981 18.9099C3.98634 19.0563 4.00534 19.204 4.05547 19.3422C4.1056 19.4805 4.18561 19.606 4.28981 19.7099C4.38325 19.8025 4.49406 19.8759 4.6159 19.9256C4.73774 19.9754 4.8682 20.0006 4.99981 19.9999H5.08981L9.25981 19.6199C9.71661 19.5744 10.1438 19.3731 10.4698 19.0499L19.4698 10.0499C19.8191 9.68083 20.0079 9.18837 19.9948 8.68039C19.9817 8.17242 19.7677 7.69037 19.3998 7.33986ZM9.07981 17.6199L6.07981 17.8999L6.34981 14.8999L11.9998 9.31986L14.6998 12.0199L9.07981 17.6199ZM15.9998 10.6799L13.3198 7.99986L15.2698 5.99986L17.9998 8.72986L15.9998 10.6799Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export default EditIcon;